module.exports = __webpack_public_path__ + "img/chat.675e88dd.jpg";